export default {
  male: '男',
  female: '女',
} as const;
